//lazy load/Suspense https://www.youtube.com/watch?v=00gQyXRL7KI
//import { lazy, Suspense } from "react";

//import Skeleton from "@material-ui/lab/Skeleton";
//import { Grid } from "@material-ui/core";

import AnimatedDeck from "./AnimatedDeck";

import { useAtom } from "jotai";
import { darkThemeAtom } from "../../atoms";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";


import { MYCOLORS } from "../../mypallette";

import { useAboutStyles } from "./AboutStyles";

//to do load when on screen
/* import useOnScreen from "../utils/useOnScreen";
import { useRef } from "react";
import { Skeleton } from "@material-ui/lab";
import { Grid } from "@material-ui/core"; */

//const AnimatedDeck = lazy(() => import("./AnimatedDeck"));
/* wrap this suspense around component that I want to lazy load
<Suspense
            fallback={
              <Grid container justifyContent="center" alignItems="center">
                <Skeleton variant="rect" width={250} height={350} />
              </Grid>
            }
          >
  </Suspense>
*/

const About = () => {
  const [darkTheme] = useAtom(darkThemeAtom);
  const classes = useAboutStyles();

  //const refAniDeck = useRef();
  // Call the hook passing in ref and root margin
  // In this case it would only be considered onScreen if more ...
  // ... than 200px of element is visible.
  //const onScreenAniDeck = useOnScreen(refAniDeck, "-10px", true);

  return (
    <>
      <Card  className={darkTheme ? classes.cardmainDark : classes.cardmainLight} elevation={4}>
        <CardHeader
          title={
            <Typography
              align='center'
              variant='h4'
              style={{ color: darkTheme ? MYCOLORS.dhighlight : MYCOLORS.lhighlight }}
            >
              About
            </Typography>
          }
        ></CardHeader>

        <CardContent>
          <AnimatedDeck />
        </CardContent>
      </Card>
    </>
  );
};

export default About;
